<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-4">
          <base-input label="Select Field">
            <el-select v-model="currentFilter" selected-filters:->
              <el-option label="Date" value="date" />
              <el-option label="Chalan Number" value="chalanNumber" />
              <el-option label="Customer Name" value="customerName" />
              <el-option label="Vendor Name" value="vendorName" />
              <el-option label="Status" value="status" />
              <el-option label="Service Request Number" value="requestNumber" />
            </el-select>
          </base-input>
        </div>
        <div class="col-md-8">
          <base-input v-if="currentFilter === 'status'" label="Select Value">
            <el-select v-model="selectedValue">
              <el-option
                v-for="(item, index) in statuses"
                :key="index"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </base-input>
          <base-input
            v-else-if="currentFilter != 'date'"
            v-model="selectedValue"
            selected-filters:-
            label="Value"
            placeholder="Type Value"
          />
          <base-input v-else label="Select Date Range">
            <el-date-picker
              v-model="selectedValue"
              type="daterange"
              range-separator="-"
              start-placeholder="Start"
              end-placeholder="End"
              value-format="yyyy-MM-dd"
            />
          </base-input>
        </div>
      </div>
      <base-button type="primary" native-type="submit">Apply</base-button>
    </el-form>
  </div>
</template>

<script>
import { Form, Select, Option, DatePicker } from "element-ui";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      currentFilter: null,
      selectedValue: null,
      statuses: [
        {
          value: "pending",
          label: "Pending",
        },
        {
          value: "dispatched",
          label: "Dispatched",
        },
        {
          value: "accepted",
          label: "Accepted",
        },
      ],
    };
  },
  methods: {
    onSubmit() {
      this.$emit("apply", {
        field: this.currentFilter,
        value: this.selectedValue,
      });
      this.currentFilter = "";
      this.selectedValue = "";
    },
  },
};
</script>

<style>
</style>